// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const InsuranceRequestWizardRequestError = require('../../../components/insuranceRequestWizard/insuranceRequestWizardRequestError/insuranceRequestWizardRequestError');
const { InsuranceRequestProductDetail } = require('../../../components/insuranceRequestProductDetail/insuranceRequestProductDetail');

// @ constants
const { COMMONS: { PRESTAMOS_PHONE } } = require('constants/mortgageRequestHolderData');
const { DISCLAIMER_MOBILE_INSURANCE } = require('constants/flagBasedFeatures');

// @ actions
const insurancesLandingActions = require('../../../actions/insuranceRequest/insuranceRequestLanding');

class InsuranceRequestProductDetailDescriptionView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { immInsurances, requestInsurancesOverallView } = this.props;

        if (!immInsurances.get('fulfilled')) {
            requestInsurancesOverallView()
        }
    }

    buildBreadcrumb(text) {
        return [
            {
                text: formatText('navbar-insurances'),
                url: '/myprofile/insurances'
            },
            {
                text: formatText(text)
            }
        ];
    }

    getImmPolicy(policyNumber) {
        const { immInsurances } = this.props;

        const insurances = immInsurances.get('insurances');
        const immPolicy = insurances.filter((insurance) => insurance.get('policyNumber') === policyNumber);

        return immPolicy.first();

    }

    buildError() {
        return (
            <InsuranceRequestWizardRequestError
                title={formatText('insuranceConsultiveProductDetails-errorTitle')}
                text={formatText('insuranceConsultiveProductDetails-errorText', [PRESTAMOS_PHONE])}
                buttonLabel={formatText('insuranceConsultiveProductDetails-errorTryAgainText')}
                buttonLink={formatText('insuranceConsultiveProductDetails-errorTryAgainUrl')}
            />
        );
    }

    buildContent() {
        const { immFlagBasedFeatures, immInsurances, match: { params: { policyNumber }, path } = {} } = this.props;

        const commercialBannerB = !__CONTACT_CENTER__ ? <CommercialAds path={path} type="banner-b" /> : null;

        if (!immInsurances.get('fulfilled')) {
            return <LoadingSection />
        }

        let content;
        const immPolicy = this.getImmPolicy(policyNumber);

        if (immInsurances.get('error') || !immPolicy) {
            content = this.buildError();
        } else {
            content = (
                <React.Fragment>
                    <div className="col-xs-12 col-lg-9 col-xl-9">
                        <InsuranceRequestProductDetail
                            isDisclaimerMobileEnabled={immFlagBasedFeatures.get(DISCLAIMER_MOBILE_INSURANCE)}
                            immPolicy={immPolicy} />
                    </div>
                    <div className="col-xs-12 col-lg-3 col-xl-9">
                        {commercialBannerB}
                    </div>
                </React.Fragment>
            );
        }

        return content;
    }

    render() {
        const { match } = this.props

        let mappingBreadcrumb;
        let title

        if (match.path.indexOf('mobile') !== -1) {
            mappingBreadcrumb = this.buildBreadcrumb('insuranceConsultiveProductDetails-mobilePageBreadcrumb');
            title = 'insuranceConsultiveProductDetails-mobilePageTitle';
        } else {
            mappingBreadcrumb = this.buildBreadcrumb('insuranceRequestHome-breadcrumb');
            title = 'insuranceRequestHome-title';
        }

        return (
            <article className="insurance-request-product-detail-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(title)}
                        />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {this.buildContent()}
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}

InsuranceRequestProductDetailDescriptionView.propTypes = {
    match: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInsurances: PropTypes.object.isRequired,
    requestInsurancesOverallView: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInsurances: state.insuranceRequestLanding,
    }),
    {
        requestInsurancesOverallView: insurancesLandingActions.requestInsurancesOverallView
    }
)(withRouter(InsuranceRequestProductDetailDescriptionView));
